import React from "react";
import moment from "moment";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { HiClock, HiUser, HiDocumentText } from "react-icons/hi";

export default ({ item }) => {
  return (
    <div className="w-full mx-auto bg-white p-4">
      {(item.logs || [])
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map((log, index) => {
          return (
            <div key={index} className="w-full grid grid-cols-4 transition-colors rounded-lg">
              <div className="relative pr-3 border-r-[2px] border-indigo-600">
                <div className="absolute h-3 w-3 bg-indigo-600 rounded-full -right-[7px] top-2 ring-2 ring-white pulse-animation" />
                <p className="text-xs font-bold text-right text-indigo-700">{moment(log.created_at).format("DD MMM")}</p>
                <p className="text-[10px] text-gray-600 text-right flex items-center justify-end">
                  <HiClock className="inline mr-1 text-indigo-500" />
                  {moment(log.created_at).fromNow()}
                </p>
              </div>
              <div className="col-span-3 pl-4 pb-4">
                <p className="text-xs font-semibold text-indigo-800 uppercase tracking-wider mb-1">{log.field}</p>
                <div className="bg-gray-50 p-2 rounded-md shadow-sm mb-2">
                  <p className="text-sm flex items-center gap-x-2 flex-wrap">
                    <span className="font-medium text-gray-700">{log.old_value || "—"}</span>
                    <MdOutlineKeyboardArrowRight className="text-indigo-500 text-xl animate-pulse" />
                    <span className="font-medium text-indigo-700">{log.new_value || "—"}</span>
                  </p>
                </div>
                {Boolean(log.text) && (
                  <div className="flex items-start mt-1 bg-yellow-50 p-2 rounded-md">
                    <HiDocumentText className="text-yellow-600 mr-2 mt-0.5" />
                    <p className="text-xs text-gray-700 italic">{log.text}</p>
                  </div>
                )}
                <p className="text-xs items-center gap-2 flex-wrap mt-2 bg-gray-100 p-1.5 rounded-full inline-flex">
                  {log.user_avatar ? <img src={log.user_avatar} className="w-5 h-5 rounded-full border-2 border-white shadow-sm" /> : <HiUser className="w-4 h-4 text-gray-500" />}
                  <span className="font-medium text-gray-700">{log.user_name}</span>
                </p>
              </div>
            </div>
          );
        })}
      {(!item.logs || item.logs.length === 0) && (
        <div className="text-center py-8 text-gray-500">
          <p className="text-lg font-medium">No activity logs yet</p>
          <p className="text-sm">Changes to this item will be recorded here</p>
        </div>
      )}
    </div>
  );
};
